export default "__VITE_ASSET__CT8fp6Vt__"